import { render } from "./ModuleTitledBlock.vue?vue&type=template&id=210ef0ea"
import script from "./ModuleTitledBlock.vue?vue&type=script&lang=js"
export * from "./ModuleTitledBlock.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__